import { createModel } from '@rematch/core';
import { Experts } from '../../api/ApiClient';
import apiConnector from '../../api/ApiConnector';

const initState: ExpertsState = {
    expertsList: null,
    expertsForDayList: null,
};

export default createModel({
    state: initState,
    reducers: {
        setExpertsList(state: ExpertsState, expertsList: Experts | null) {
            return { ...state, expertsList };
        },
        setExpertsForDayList(state: ExpertsState, expertsForDayList: Experts | null) {
            return { ...state, expertsForDayList };
        },
        clearExpertsForDayList(state: ExpertsState) {
            return { ...state, expertsForDayList: null };
        },
    },
    effects: (dispatch: any) => ({
        async getExpertsAsync(payload: GetExpertPayload) {
            const expertsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExperts(
                true,
                payload.qualificationId ? [payload.qualificationId] : undefined,
                 undefined,
                undefined,
                undefined,
                    payload.searchField,
                    payload.searchTerm,
                    payload.page,
                    payload.pageSize,
                    payload.sortOrder,
                    payload.sortField,
                ));

            if (!expertsList) return;

            this.setExpertsList(expertsList);
        },
        async getExpertsForDayAsync(payload: GetExpertForDayPayload) {
            const expertsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertsForDay(
                    payload.examDayId,
                    payload.page,
                    payload.pageSize,
                    payload.sortOrder,
                    payload.sortField,
                ));

            this.setExpertsForDayList(expertsList);
        },
        clearExpertsList() {
            this.setExpertsList(null);
        },
    }),
});

interface ExpertsState {
    expertsList: Experts | null;
    expertsForDayList: Experts | null;
}

export interface GetExpertPayload {
    qualificationId?: string;
    examId?: string;
    onlyAcEmployees?: boolean;
    onlySelected?: boolean;
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

export interface GetExpertForDayPayload {
    examDayId: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface IGetAvailableExamExperts {
    onlyEmployees: boolean;
    qualificationId: string;
}
